import React from 'react'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { Button, Tooltip } from '@mui/material'
import AdjustIcon from '@mui/icons-material/Adjust'
import BaseMapControl from './BaseMapControl'
import { setAddMode } from '../../../redux/slices/Map/map'

/**
 * Control para captura de ubicación GPS
 * Se muestra condicionalmente según el contexto de la página
 */
class LocationCaptureControl extends BaseMapControl {
  constructor(store, theme, shouldShow) {
    super({ className: 'location-capture-control' })
    this.store = store
    this.theme = theme
    this.shouldShow = shouldShow
  }

  onAdd(map) {
    // Solo agregar el control si debe mostrarse
    if (!this.shouldShow()) {
      const emptyDiv = document.createElement('div')
      emptyDiv.style.display = 'none'
      return emptyDiv
    }
    return super.onAdd(map)
  }

  _renderContent() {
    if (!this.shouldShow()) {
      return
    }

    const CaptureButton = () => {
      const dispatch = useDispatch()
      const addMode = useSelector(state => state.mapState.addMode)
      const [isHovered, setIsHovered] = React.useState(false)

      const handleToggle = () => {
        dispatch(setAddMode(!addMode))
      }

      const buttonStyles = {
        minWidth: '30px',
        width: '30px',
        height: '30px',
        padding: 0,
        margin: 0,
        color: this.theme.palette.text.primary,
        bgcolor:
          addMode || isHovered
            ? this.theme.palette.secondary.main
            : this.theme.palette.text.primary,
        border: 'none',
        opacity: 1,
        cursor: 'pointer',
        '&:hover': {
          bgcolor: this.theme.palette.secondary.main,
          color: this.theme.palette.primary.main,
        },
      }

      // Ocultar el botón mientras el modo de captura está activo
      if (addMode) return null

      return (
        <Tooltip title="Capturar nueva ubicación" placement="right">
          <span>
            <Button
              onClick={handleToggle}
              size="small"
              sx={buttonStyles}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}>
              <AdjustIcon fontSize="small" />
            </Button>
          </span>
        </Tooltip>
      )
    }

    this._root.render(
      <Provider store={this.store}>
        <CaptureButton />
      </Provider>
    )
  }

  /**
   * Actualizar visibilidad del control
   */
  updateVisibility(shouldShow) {
    this.shouldShow = shouldShow
    if (this._container) {
      this._container.style.display = shouldShow() ? 'block' : 'none'
    }
  }
}

export default LocationCaptureControl
